import fetch from 'unfetch';
import {
  updateFromBackend,
  addSecurityPackageLink,
} from '../actions/orderActions';
import {
  backEndError,
  voucherError,
  abandonBasketError,
} from '../actions/errorsActions';
import {
  receivedDibsForm,
  stopLoading,
  startSubmitLoading, updateAbandonBasketState,
} from '../actions/appearanceActions';

const API_ROOT =
  process.env.NODE_ENV === 'development' ? 'http://localhost:3004/' : '/'; // eslint-disable-line global-require

const callApi = (endpoint, data, method = 'POST') => {
  const fullUrl =
    endpoint.indexOf(API_ROOT) === -1 ? API_ROOT + endpoint : endpoint;

  const params = {
    method,
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
    },
  };

  // Edge doesn't allow even empty body
  if (method === 'POST') {
    params.body = JSON.stringify(data);
  }

  return fetch(fullUrl,
    params)
    .then(response => {
      const contentType = response.headers.get('content-type');

      if (contentType && contentType.indexOf('application/json') !== -1) {
        return response.json().then(responseJson => {
          if (responseJson.error_code !== undefined) {
            return Promise.reject(responseJson);
          }

          return responseJson;
        });
      }
      return response;
    });
};

export default {
  postOrder: (data, dispatch) =>
    callApi('novasol-api/orders',
      data).then(
      newOrder => {
        dispatch(updateFromBackend(newOrder));
        dispatch(addSecurityPackageLink(newOrder));
        return newOrder;
      },
      error => Promise.reject(dispatch(backEndError(error)))
    ),

  phoneValidate: (phoneNumber, dispatch) =>
    callApi('/validate/number/' + phoneNumber, '', 'GET').then(
      phoneValidate => {
        return phoneValidate.validation ?? true;
      },
      error => Promise.reject(dispatch(backEndError(error)))
    ),

  submitOrder: (data, dispatch) =>
    callApi('booking-flow-submit',
      data).then(
      updatedData => {
        if (updatedData.redirect_url !== undefined) {
          window.location.href = updatedData.redirect_url;
        }
        if (updatedData.form !== undefined) {
          dispatch(receivedDibsForm(updatedData));
        }
      },
      error => Promise.reject(dispatch(backEndError(error)))
    ),

  // @todo consider to move it to redux data flow without Select.Async
  getCountries: () =>
    callApi('novasol-api/countries-translation',
      null,
      'GET').then(data => ({
      options: data.map(countryData => ({
        text: countryData.name,
        value: countryData.iso,
      })),
    })),

  getTravelAgencies: salesMarket =>
    callApi(`novasol-api/travel-agencies/${salesMarket}`,
      null,
      'GET').then(
      data => ({
        options: data.map(agencyData => ({
          text: agencyData.agencyCity ? `${agencyData.agencyName}, ${agencyData.agencyCity}` : `${agencyData.agencyName}`,
          value: agencyData.agencyNumber,
        })),
      })
    ),

  validateVoucherBackend: (data, dispatch) =>
    callApi('novasol-voucher/validate',
      data)
      .then(newOrder => {
        dispatch(voucherError(null));
        dispatch(updateFromBackend(newOrder));
        dispatch(addSecurityPackageLink(newOrder));
        return newOrder;
      })
      .catch(error => {
        dispatch(voucherError(error));
        dispatch(stopLoading());
      }),

  sendAbandonBasket: (data, dispatch) =>
    callApi('abandon-basket/send',
      data)
      .then(newOrder => {
        dispatch(abandonBasketError(null));
        dispatch(updateAbandonBasketState(true));
        dispatch(startSubmitLoading(false));
        return newOrder;
      })
      .catch(error => {
        dispatch(abandonBasketError(error));
        dispatch(startSubmitLoading(false));
      }),
};
